// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Health Status Page ───────────────────────────────────────────────────── */

/* Info banner */
.health-info-banner {
  display: flex;
  align-items: center;
  gap: 16px;
  background: linear-gradient(135deg, #e6f9f1 0%, #f0fdf4 100%);
  border: 1px solid #86BC25;
  border-radius: 12px;
  padding: 20px 24px;
  margin-bottom: 32px;
  box-shadow: 0 2px 8px rgba(134, 188, 37, 0.08);
}

.health-info-banner__icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #86BC25;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.health-info-banner__icon svg {
  font-size: 28px;
}

.health-info-banner__text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.health-info-banner__text strong {
  font-size: 16px;
  font-weight: 700;
  color: #111827;
}

.health-info-banner__text span {
  font-size: 13px;
  color: #6b7280;
}

/* Service grid */
.health-service-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(420px, 1fr));
  gap: 24px;
}

/* Service card */
.health-service-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: box-shadow 0.2s, transform 0.2s;
  position: relative;
}

.health-service-card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
}

/* Card header */
.health-service-card__header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 24px 24px 20px;
  border-bottom: 1px solid #f3f4f6;
  background: linear-gradient(180deg, #fafafa 0%, #ffffff 100%);
}

.health-service-card__icon {
  width: 56px;
  height: 56px;
  border-radius: 12px;
  background: linear-gradient(135deg, #f0fdf4 0%, #e6f9f1 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 2px 8px rgba(134, 188, 37, 0.12);
}

.health-service-card__icon svg {
  font-size: 32px;
}

.health-service-card__title-wrap {
  flex: 1 1;
  min-width: 0;
}

.health-service-card__title {
  font-size: 18px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 4px 0;
  letter-spacing: -0.01em;
}

.health-service-card__desc {
  font-size: 13px;
  color: #6b7280;
  margin: 0;
  line-height: 1.5;
}

.health-service-card__actions {
  display: flex;
  gap: 4px;
}

/* Card body */
.health-service-card__body {
  padding: 24px;
}

.health-service-card__loading,
.health-service-card__error {
  text-align: center;
  padding: 32px 16px;
  color: #6b7280;
  font-size: 14px;
}

.health-service-card__error {
  color: #dc2626;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

/* Metrics grid */
.health-service-card__metrics {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-bottom: 20px;
}

.health-metric {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.health-metric__label {
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.health-metric__value {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  font-family: 'Consolas', 'Monaco', monospace;
}

/* Status badge */
.health-status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 20px;
  border: 1px solid;
  font-size: 13px;
  font-weight: 600;
  transition: transform 0.15s;
}

.health-status-badge:hover {
  transform: scale(1.05);
}

.health-status-badge--small {
  padding: 4px 10px;
  font-size: 12px;
  gap: 5px;
}

.health-status-badge svg {
  font-size: inherit;
}

/* Expand button */
.health-service-card__expand-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 12px 16px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  font-family: inherit;
  transition: background 0.15s, border-color 0.15s;
}

.health-service-card__expand-btn:hover {
  background: #f3f4f6;
  border-color: #d1d5db;
}

.health-expand-icon--rotated {
  transform: rotate(180deg);
}

.health-expand-icon--rotated,
.health-service-card__expand-btn svg {
  transition: transform 0.2s;
}

/* Compact component status pills — used by the GitHub status card, which can
   have far more components (10+) than the internal service cards' checks
   list; a wrap-grid of small pills keeps the card height in line with its
   siblings instead of growing one full row per component. */
.health-component-pill-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 16px 0 0;
}

.health-component-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 20px;
  border: 1px solid;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.health-component-pill__dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex-shrink: 0;
}

.health-component-pill__name {
  color: #111827;
}

/* Component checks */
.health-component-checks {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 0 0;
}

.health-component-check {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 14px;
  background: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  transition: background 0.15s;
}

.health-component-check:hover {
  background: #f5f5f5;
}

.health-component-check__icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.health-component-check__icon svg {
  font-size: 20px;
}

.health-component-check__body {
  flex: 1 1;
  min-width: 0;
}

.health-component-check__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 6px;
}

.health-component-check__name {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
}

.health-component-check__meta {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #6b7280;
}

.health-component-check__divider {
  color: #d1d5db;
}

.health-component-check__id {
  font-family: 'Consolas', 'Monaco', monospace;
  font-size: 11px;
  color: #9ca3af;
}

/* Refresh indicator */
.health-service-card__refresh-indicator {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 16px;
  background: linear-gradient(90deg, rgba(134, 188, 37, 0.05) 0%, rgba(134, 188, 37, 0.1) 100%);
  border-top: 1px solid rgba(134, 188, 37, 0.2);
  font-size: 12px;
  color: #6b7280;
  animation: health-refresh-pulse 1.5s ease-in-out infinite;
}

.health-refresh-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #86BC25;
  animation: health-refresh-dot-pulse 1.5s ease-in-out infinite;
}

/* Animations */
@keyframes health-refresh-pulse {
  0%, 100% {
    opacity: 0.8;
  }
  50% {
    opacity: 1;
  }
}

@keyframes health-refresh-dot-pulse {
  0%, 100% {
    transform: scale(1);
    opacity: 0.6;
  }
  50% {
    transform: scale(1.3);
    opacity: 1;
  }
}

.health-refresh-spin {
  animation: health-refresh-spin 1s linear infinite;
}

@keyframes health-refresh-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Responsive */
@media (max-width: 1024px) {
  .health-service-grid {
    grid-template-columns: 1fr;
  }

  .health-service-card__metrics {
    grid-template-columns: 1fr;
    gap: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ecrOps/EcrOpsHealthStatus.css"],"names":[],"mappings":"AAAA,gFAAgF;;AAEhF,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,gCAAgC;EAChC,6DAA6D;AAC/D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA,cAAc;AACd;EACE,aAAa;AACf;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,4CAA4C;AAC9C;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;;4DAG4D;AAC5D;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4CAA4C;EAC5C,eAAe;EACf,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,6FAA6F;EAC7F,6CAA6C;EAC7C,eAAe;EACf,cAAc;EACd,yDAAyD;AAC3D;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,6DAA6D;AAC/D;;AAEA,eAAe;AACf;EACE;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;AACF;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF","sourcesContent":["/* ── Health Status Page ───────────────────────────────────────────────────── */\n\n/* Info banner */\n.health-info-banner {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  background: linear-gradient(135deg, #e6f9f1 0%, #f0fdf4 100%);\n  border: 1px solid #86BC25;\n  border-radius: 12px;\n  padding: 20px 24px;\n  margin-bottom: 32px;\n  box-shadow: 0 2px 8px rgba(134, 188, 37, 0.08);\n}\n\n.health-info-banner__icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: #86BC25;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.health-info-banner__icon svg {\n  font-size: 28px;\n}\n\n.health-info-banner__text {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.health-info-banner__text strong {\n  font-size: 16px;\n  font-weight: 700;\n  color: #111827;\n}\n\n.health-info-banner__text span {\n  font-size: 13px;\n  color: #6b7280;\n}\n\n/* Service grid */\n.health-service-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(420px, 1fr));\n  gap: 24px;\n}\n\n/* Service card */\n.health-service-card {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n  transition: box-shadow 0.2s, transform 0.2s;\n  position: relative;\n}\n\n.health-service-card:hover {\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);\n  transform: translateY(-2px);\n}\n\n/* Card header */\n.health-service-card__header {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 24px 24px 20px;\n  border-bottom: 1px solid #f3f4f6;\n  background: linear-gradient(180deg, #fafafa 0%, #ffffff 100%);\n}\n\n.health-service-card__icon {\n  width: 56px;\n  height: 56px;\n  border-radius: 12px;\n  background: linear-gradient(135deg, #f0fdf4 0%, #e6f9f1 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  box-shadow: 0 2px 8px rgba(134, 188, 37, 0.12);\n}\n\n.health-service-card__icon svg {\n  font-size: 32px;\n}\n\n.health-service-card__title-wrap {\n  flex: 1;\n  min-width: 0;\n}\n\n.health-service-card__title {\n  font-size: 18px;\n  font-weight: 700;\n  color: #111827;\n  margin: 0 0 4px 0;\n  letter-spacing: -0.01em;\n}\n\n.health-service-card__desc {\n  font-size: 13px;\n  color: #6b7280;\n  margin: 0;\n  line-height: 1.5;\n}\n\n.health-service-card__actions {\n  display: flex;\n  gap: 4px;\n}\n\n/* Card body */\n.health-service-card__body {\n  padding: 24px;\n}\n\n.health-service-card__loading,\n.health-service-card__error {\n  text-align: center;\n  padding: 32px 16px;\n  color: #6b7280;\n  font-size: 14px;\n}\n\n.health-service-card__error {\n  color: #dc2626;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n/* Metrics grid */\n.health-service-card__metrics {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 16px;\n  margin-bottom: 20px;\n}\n\n.health-metric {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.health-metric__label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.health-metric__value {\n  font-size: 14px;\n  font-weight: 600;\n  color: #111827;\n  font-family: 'Consolas', 'Monaco', monospace;\n}\n\n/* Status badge */\n.health-status-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border-radius: 20px;\n  border: 1px solid;\n  font-size: 13px;\n  font-weight: 600;\n  transition: transform 0.15s;\n}\n\n.health-status-badge:hover {\n  transform: scale(1.05);\n}\n\n.health-status-badge--small {\n  padding: 4px 10px;\n  font-size: 12px;\n  gap: 5px;\n}\n\n.health-status-badge svg {\n  font-size: inherit;\n}\n\n/* Expand button */\n.health-service-card__expand-btn {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 12px 16px;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 600;\n  color: #374151;\n  font-family: inherit;\n  transition: background 0.15s, border-color 0.15s;\n}\n\n.health-service-card__expand-btn:hover {\n  background: #f3f4f6;\n  border-color: #d1d5db;\n}\n\n.health-expand-icon--rotated {\n  transform: rotate(180deg);\n}\n\n.health-expand-icon--rotated,\n.health-service-card__expand-btn svg {\n  transition: transform 0.2s;\n}\n\n/* Compact component status pills — used by the GitHub status card, which can\n   have far more components (10+) than the internal service cards' checks\n   list; a wrap-grid of small pills keeps the card height in line with its\n   siblings instead of growing one full row per component. */\n.health-component-pill-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 16px 0 0;\n}\n\n.health-component-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 10px;\n  border-radius: 20px;\n  border: 1px solid;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.health-component-pill__dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.health-component-pill__name {\n  color: #111827;\n}\n\n/* Component checks */\n.health-component-checks {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 16px 0 0;\n}\n\n.health-component-check {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  padding: 14px;\n  background: #fafafa;\n  border: 1px solid #f0f0f0;\n  border-radius: 8px;\n  transition: background 0.15s;\n}\n\n.health-component-check:hover {\n  background: #f5f5f5;\n}\n\n.health-component-check__icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 8px;\n  background: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n}\n\n.health-component-check__icon svg {\n  font-size: 20px;\n}\n\n.health-component-check__body {\n  flex: 1;\n  min-width: 0;\n}\n\n.health-component-check__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 6px;\n}\n\n.health-component-check__name {\n  font-size: 14px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.health-component-check__meta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.health-component-check__divider {\n  color: #d1d5db;\n}\n\n.health-component-check__id {\n  font-family: 'Consolas', 'Monaco', monospace;\n  font-size: 11px;\n  color: #9ca3af;\n}\n\n/* Refresh indicator */\n.health-service-card__refresh-indicator {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 8px 16px;\n  background: linear-gradient(90deg, rgba(134, 188, 37, 0.05) 0%, rgba(134, 188, 37, 0.1) 100%);\n  border-top: 1px solid rgba(134, 188, 37, 0.2);\n  font-size: 12px;\n  color: #6b7280;\n  animation: health-refresh-pulse 1.5s ease-in-out infinite;\n}\n\n.health-refresh-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #86BC25;\n  animation: health-refresh-dot-pulse 1.5s ease-in-out infinite;\n}\n\n/* Animations */\n@keyframes health-refresh-pulse {\n  0%, 100% {\n    opacity: 0.8;\n  }\n  50% {\n    opacity: 1;\n  }\n}\n\n@keyframes health-refresh-dot-pulse {\n  0%, 100% {\n    transform: scale(1);\n    opacity: 0.6;\n  }\n  50% {\n    transform: scale(1.3);\n    opacity: 1;\n  }\n}\n\n.health-refresh-spin {\n  animation: health-refresh-spin 1s linear infinite;\n}\n\n@keyframes health-refresh-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Responsive */\n@media (max-width: 1024px) {\n  .health-service-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .health-service-card__metrics {\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
